import React, { useMemo, useState } from 'react';
import { Tabs } from '@douyinfe/semi-ui';
import TokenQueryPanel from './TokenQueryPanel';
import TokenMergePanel from './TokenMergePanel';

const { TabPane } = Tabs;

function parseBaseUrls() {
    try {
        const parsed = JSON.parse(process.env.REACT_APP_BASE_URL || '{}');
        if (parsed && typeof parsed === 'object' && Object.keys(parsed).length > 0) {
            return parsed;
        }
    } catch (error) {
        console.error('Failed to parse REACT_APP_BASE_URL:', error);
    }

    return {
        default: process.env.REACT_APP_SERVER || window.location.origin,
    };
}

const SelfServiceSystem = () => {
    const baseUrls = useMemo(() => parseBaseUrls(), []);
    const baseUrlKeys = Object.keys(baseUrls);
    const [activeBaseKey, setActiveBaseKey] = useState(baseUrlKeys[0]);

    const renderFeatureTabs = (baseUrl) => (
        <Tabs type="line" defaultActiveKey="query">
            <TabPane tab="令牌查询" itemKey="query">
                <TokenQueryPanel key={`query-${baseUrl}`} baseUrl={baseUrl} />
            </TabPane>
            <TabPane tab="令牌合并" itemKey="merge">
                <TokenMergePanel key={`merge-${baseUrl}`} baseUrl={baseUrl} />
            </TabPane>
        </Tabs>
    );

    if (baseUrlKeys.length === 1) {
        return renderFeatureTabs(baseUrls[activeBaseKey]);
    }

    return (
        <Tabs type="line" activeKey={activeBaseKey} onChange={setActiveBaseKey}>
            {baseUrlKeys.map((key) => (
                <TabPane key={key} itemKey={key} tab={key}>
                    {renderFeatureTabs(baseUrls[key])}
                </TabPane>
            ))}
        </Tabs>
    );
};

export default SelfServiceSystem;
